import { db, analytics, logEvent } from './firebase.js';
import { collection, getDocs } from "firebase/firestore";

// Selectors
const postsList = document.getElementById('posts-list');
const filterInput = document.getElementById('filter-input');
const blogContent = document.getElementById('blog-content');
const contentPlaceholder = document.getElementById('content-placeholder');
const contentViewer = document.getElementById('content-viewer');
const contentTitle = document.getElementById('content-title');
const contentMeta = document.getElementById('content-meta');
const contentBody = document.getElementById('content-body');
const contentImage = document.getElementById('content-image');
const menuToggle = document.getElementById('menu-toggle');
const sidebar = document.querySelector('.blog-sidebar');

let allPosts = []; // Cache for posts

// Mobile Menu Toggle
if (menuToggle && sidebar) {
    menuToggle.addEventListener('click', () => {
        sidebar.classList.toggle('active');
        const icon = menuToggle.querySelector('i');
        if (icon && window.lucide) {
            const isOpened = sidebar.classList.contains('active');
            icon.setAttribute('data-lucide', isOpened ? 'x' : 'menu');
            lucide.createIcons();
        }
    });
}

async function fetchPosts() {
    try {
        const querySnapshot = await getDocs(collection(db, "posts"));
        let docs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

        // Custom sort by date string (handling ISO and DD/MM/YYYY)
        docs.sort((a, b) => {
            const parseDate = (dStr) => {
                if (!dStr) return 0;
                const d = new Date(dStr);
                if (!isNaN(d.getTime())) return d.getTime();
                const parts = dStr.split('/');
                if (parts.length === 3) return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`).getTime();
                return 0;
            };
            return parseDate(b.date) - parseDate(a.date);
        });

        allPosts = docs;
        renderBlog(allPosts);
        checkDeepLink();
    } catch (error) {
        console.error("Error fetching posts:", error);
        if (postsList) postsList.innerHTML = '<p style="text-align:center; padding: 1rem;">Yazılar yüklenirken bir hata oluştu.</p>';
    }
}

function trToSlug(text) {
    if (!text) return '';
    const mapping = {
        'ç': 'c', 'ğ': 'g', 'ı': 'i', 'ö': 'o', 'ş': 's', 'ü': 'u',
        'Ç': 'c', 'Ğ': 'g', 'İ': 'i', 'Ö': 'o', 'Ş': 's', 'Ü': 'u'
    };
    let slug = text.toString().toLowerCase().trim();
    for (let char in mapping) {
        slug = slug.replace(new RegExp(char, 'g'), mapping[char]);
    }
    return slug
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-');
}

function renderBlog(posts) {
    if (!postsList) return;
    postsList.innerHTML = '';

    if (posts.length === 0) {
        postsList.innerHTML = '<p style="padding: 1rem; color: #888;">Yazı bulunamadı.</p>';
        return;
    }

    posts.forEach(post => {
        const card = document.createElement('div');
        card.className = 'post-card';
        card.dataset.id = post.id;
        card.innerHTML = `
            <div class="post-card-category">${post.category || 'Genel'}</div>
            <div class="post-card-title">${post.title}</div>
            <div class="post-card-date">${post.date || ''}</div>
        `;
        card.onclick = () => openPost(post);
        postsList.appendChild(card);
    });
}

function openPost(post) {
    // UI Update
    if (contentPlaceholder) contentPlaceholder.style.display = 'none';
    if (contentViewer) contentViewer.style.display = 'block';

    if (contentTitle) contentTitle.innerText = post.title;
    if (contentMeta) {
        contentMeta.innerText = `${post.category || ''} • ${post.author || 'Le Chatbot'} • ${post.date || ''}`;
    }
    if (contentBody) {
        contentBody.innerHTML = post.content || '<p>İçerik bulunamadı.</p>';
    }
    if (contentImage) {
        if (post.image) {
            contentImage.style.backgroundImage = `url('${post.image}')`;
            contentImage.style.display = 'block';
        } else {
            contentImage.style.display = 'none';
        }
    }

    // Mark active in sidebar
    document.querySelectorAll('.post-card').forEach(el => {
        el.classList.toggle('active', el.dataset.id === post.id);
    });

    // Close sidebar on mobile
    if (sidebar && sidebar.classList.contains('active')) {
        sidebar.classList.remove('active');
        const icon = menuToggle.querySelector('i');
        if (icon && window.lucide) {
            icon.setAttribute('data-lucide', 'menu');
            lucide.createIcons();
        }
    }

    // Scroll content to top
    if (blogContent) blogContent.scrollTo(0, 0);

    // Update URL & Title
    const slug = trToSlug(post.title);
    history.pushState({ postId: post.id }, post.title, `?post=${slug}`);
    document.title = `${post.title} - Le Chatbot Blog`;

    // Log Analytics Event
    if (analytics) {
        logEvent(analytics, 'page_view', {
            page_title: post.title,
            page_location: window.location.href,
            page_path: window.location.pathname + window.location.search
        });
    }
}

// Filtering
if (filterInput) {
    filterInput.oninput = (e) => {
        const term = e.target.value.toLowerCase();
        const filtered = allPosts.filter(post =>
            post.title.toLowerCase().includes(term) ||
            (post.category && post.category.toLowerCase().includes(term)) ||
            (post.excerpt && post.excerpt.toLowerCase().includes(term))
        );
        renderBlog(filtered);
    };
}

// Deep Linking & Default Selection
function checkDeepLink() {
    const urlParams = new URLSearchParams(window.location.search);
    const slug = urlParams.get('post');
    if (slug && allPosts.length > 0) {
        const post = allPosts.find(p => trToSlug(p.title) === slug);
        if (post) {
            openPost(post);
            return;
        }
    }

    // Default to latest post if no deep link or post not found
    if (allPosts.length > 0) {
        openPost(allPosts[0]);
    }
}

// Navigation
window.onpopstate = (event) => {
    if (event.state && event.state.postId) {
        const post = allPosts.find(p => p.id === event.state.postId);
        if (post) openPost(post);
    } else {
        location.reload(); // Simplest way to reset to placeholder
    }
};

// Init
fetchPosts();
